import { XLSX_MIME_TYPE } from "@repo/utils";
import type { GetAllInput } from "@types_def/common/filter.types";
import type Driver from "@types_def/models/driver.types";
import { navigateToBuffer } from "@/utils/download";

import { sendRequest } from "../../clients/axios";

export function downloadDrivers(filters: GetAllInput<Driver, "id">) {
  return sendRequest<GetAllInput<Driver, "id">, { data: Iterable<number> }>(
    "post",
    "drivers/downloadXlsx",
    filters
  ).then((res) => {
    if (res.status === 201) {
      navigateToBuffer(new Uint8Array(res.data.data), XLSX_MIME_TYPE);
    }
  });
}
